var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn reports" },
    [
      _c(
        "b-row",
        { attrs: { id: "teamFilter" } },
        [
          _c("b-col", { attrs: { lg: "2", offset: "10" } }, [
            _c("div", [
              _vm._v("\n      " + _vm._s(_vm.$t("Users")) + "\n        "),
              _c(
                "div",
                [
                  _c("b-form-select", {
                    staticStyle: { "text-transform": "capitalize" },
                    attrs: { options: _vm.users },
                    model: {
                      value: _vm.userID,
                      callback: function($$v) {
                        _vm.userID = $$v
                      },
                      expression: "userID"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-row",
            {
              directives: [
                {
                  name: "match-heights",
                  rawName: "v-match-heights",
                  value: { el: [".eq-height"] },
                  expression: "{el: ['.eq-height']}"
                }
              ]
            },
            _vm._l(_vm.reportCards, function(reportCard) {
              return _vm.showReportCards
                ? _c(
                    "b-col",
                    { key: reportCard["id"], attrs: { lg: "2" } },
                    [
                      _c(
                        "b-card",
                        {
                          directives: [{ name: "ripple", rawName: "v-ripple" }],
                          staticClass: "eq-height text-black bg-white",
                          attrs: { "no-body": "" },
                          on: {
                            click: function($event) {
                              _vm.pCardFilter(reportCard["text"])
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "bar",
                            class: reportCard["bg"]
                          }),
                          _vm._v(" "),
                          _c(
                            "b-card-body",
                            [
                              _c("b-row", { staticClass: "top-layer" }, [
                                _c(
                                  "div",
                                  { staticClass: "h1 mb-0" },
                                  [
                                    _c("animated-number", {
                                      attrs: {
                                        value: reportCard["value"] || 0,
                                        formatValue: _vm.formatNumber,
                                        duration: 1000
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "h1 text-right mb-4",
                                    class: reportCard["tc"]
                                  },
                                  [_c("i", { class: reportCard["icon"] })]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "text-black text-uppercase font-weight-bold"
                                },
                                [
                                  _c("strong", [
                                    _c(
                                      "div",
                                      { staticStyle: { height: "36px" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "UPLOAD_DROPDOWN." +
                                                reportCard["key"]
                                            )
                                          )
                                        ),
                                        _c("br")
                                      ]
                                    )
                                  ]),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("ANALYTICS.TOTAL_PROCESSED")
                                      ) +
                                      " : " +
                                      _vm._s(reportCard["processed"])
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("ANALYTICS.TOTAL_REJECTED")
                                      ) +
                                      " : " +
                                      _vm._s(reportCard["rejected"])
                                  ),
                                  _c("br")
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-progress", {
                                staticClass: "progress-black progress-xs mt-3",
                                attrs: { value: 25 }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "b-col",
                    { attrs: { lg: "2" } },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "eq-height text-black bg-white",
                          attrs: { "no-body": "" }
                        },
                        [
                          _c(
                            "b-card-body",
                            [
                              _c(
                                "content-placeholders",
                                [
                                  _c("content-placeholders-img", {
                                    staticStyle: { height: "140px" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
            })
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "4" } },
                [
                  _c(
                    "b-card",
                    { staticClass: "bg-white", attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-row",
                        {
                          staticClass: "ml-0",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [
                          _c("h5", [
                            _vm._v(
                              _vm._s(_vm.$t("ANALYTICS.FORM_WORKFLOW_STATS"))
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card-body",
                        [
                          _vm.showChart
                            ? _c(
                                "timeline",
                                _vm._l(_vm.processWorkflowStat, function(
                                  count,
                                  processed
                                ) {
                                  return _c(
                                    "timeline-item",
                                    {
                                      key: processed,
                                      class: "stats-" + processed
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "h5 font-weight-bold" },
                                        [
                                          _c("animated-number", {
                                            attrs: {
                                              value: count || 0,
                                              formatValue: _vm.formatNumber,
                                              duration: 1000
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "COMMON." +
                                                processed.toUpperCase()
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                })
                              )
                            : _c(
                                "content-placeholders",
                                [
                                  _c("content-placeholders-img", {
                                    staticStyle: { height: "300px" }
                                  })
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { lg: "8" } },
                [
                  _c(
                    "b-card",
                    { staticClass: "bg-white", attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-row",
                        {
                          staticClass: "p-0",
                          staticStyle: { "margin-top": "-19px" },
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "3" } },
                            [
                              _vm.selectedDateFilterType === "week"
                                ? _c("h5", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("ANALYTICS.WEEKLY_REPORT")
                                        )
                                    )
                                  ])
                                : _c("h5", [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("ANALYTICS.DAILY_REPORT"))
                                    )
                                  ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "1.5" } },
                            [
                              _c("h6", [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("COMMON.FILTER_BY")) + " "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "group-by", attrs: { sm: "2" } },
                            [
                              _c("b-form-select", {
                                attrs: { options: _vm.setFilterOptions },
                                model: {
                                  value: _vm.selectedDateFilterType,
                                  callback: function($$v) {
                                    _vm.selectedDateFilterType = $$v
                                  },
                                  expression: "selectedDateFilterType"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "1.5" } },
                            [
                              _c("h6", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("COMMON.DATE_RANGE")) +
                                    " "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "4" } },
                            [
                              _c("date-picker", {
                                attrs: {
                                  range: "",
                                  lang: "en",
                                  format: "YYYY-MM-DD",
                                  "append-to-body": "",
                                  clearable: false,
                                  width: "220px"
                                },
                                model: {
                                  value: _vm.dateRange,
                                  callback: function($$v) {
                                    _vm.dateRange = $$v
                                  },
                                  expression: "dateRange"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card-body",
                        [
                          _vm.showChart
                            ? _c("line-chart", {
                                attrs: {
                                  lineData: _vm.lineData,
                                  lineLabels: _vm.lineLabels,
                                  height: 247
                                }
                              })
                            : _c(
                                "content-placeholders",
                                [
                                  _c("content-placeholders-img", {
                                    staticStyle: { height: "300px" }
                                  })
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "recent-forms" } },
            [
              _c(
                "b-card",
                {
                  staticClass: "received-form",
                  attrs: { "no-body": "", "bg-variant": "light" }
                },
                [
                  _c(
                    "b-row",
                    {
                      staticClass: "p-0",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c(
                        "b-col",
                        { staticClass: "mt-auto", attrs: { sm: "3" } },
                        [
                          _c("h5", [
                            _vm._v(_vm._s(_vm.$t("ANALYTICS.RECENT_FORMS")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "mt-auto",
                          staticStyle: { "margin-left": "-78px" },
                          attrs: { sm: "0" }
                        },
                        [
                          _c("h6", [
                            _vm._v(_vm._s(_vm.$t("ANALYTICS.PROCESS_TYPE")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-auto", attrs: { sm: "3" } },
                        [
                          _c("b-form-select", {
                            staticStyle: { "text-transform": "capitalize" },
                            attrs: { options: _vm.setOptions },
                            on: { input: _vm.filterProcessedFormsByType },
                            model: {
                              value: _vm.selectedProcessType,
                              callback: function($$v) {
                                _vm.selectedProcessType = $$v
                              },
                              expression: "selectedProcessType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-auto", attrs: { sm: "0" } },
                        [
                          _vm.selectedProcessType == "enrollment forms"
                            ? _c("h6", [
                                _vm._v(_vm._s(_vm.$t("ANALYTICS.TEMPLATE")))
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-auto", attrs: { sm: "2" } },
                        [
                          _vm.selectedProcessType == "enrollment forms"
                            ? _c("b-form-select", {
                                staticStyle: { "text-transform": "capitalize" },
                                attrs: { options: _vm.templates },
                                on: {
                                  input: _vm.filterProcessedFormsByTemplate
                                },
                                model: {
                                  value: _vm.selectedTemplate,
                                  callback: function($$v) {
                                    _vm.selectedTemplate = $$v
                                  },
                                  expression: "selectedTemplate"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-auto", attrs: { sm: "3" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { staticClass: "mt-auto", attrs: { xs: "6" } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("COMMON.PROCESSED")) +
                                      "\n                "
                                  ),
                                  _c("c-switch", {
                                    attrs: {
                                      type: "3d",
                                      variant: "success",
                                      checked: _vm.filterProcessed
                                    },
                                    on: { change: _vm.pSwitchChanged }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { staticClass: "mt-auto", attrs: { xs: "6" } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("COMMON.REJECTED")) +
                                      "\n                "
                                  ),
                                  _c("c-switch", {
                                    attrs: {
                                      type: "3d",
                                      variant: "danger",
                                      checked: _vm.filterRejected
                                    },
                                    on: { change: _vm.rSwitchChanged }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "report-table" },
                    [
                      _vm.showProcessedForms
                        ? _c("b-table", {
                            attrs: {
                              "show-empty": "",
                              striped: "",
                              "empty-text": _vm.$t("COMMON.NO_RECORD"),
                              hover: "",
                              responsive: "sm",
                              variant: "danger",
                              items: _vm.processedForms,
                              fields: _vm.tableFields,
                              "sort-by": _vm.sortBy,
                              "sort-desc": _vm.sortDesc
                            },
                            on: {
                              "update:sortBy": function($event) {
                                _vm.sortBy = $event
                              },
                              "update:sortDesc": function($event) {
                                _vm.sortDesc = $event
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "HEAD_title",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_pages",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_confidence_score",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_identified",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_rejection_reason",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_view_link",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        : _c(
                            "content-placeholders",
                            [
                              _c("content-placeholders-text", {
                                attrs: { lines: 12 }
                              })
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _c(
                        "infinite-loading",
                        {
                          ref: "infiniteLoading",
                          attrs: { distance: _vm.distance, spinner: "spiral" },
                          on: { infinite: _vm.infiniteHandler }
                        },
                        [
                          _c("div", {
                            attrs: { slot: "no-more" },
                            slot: "no-more"
                          }),
                          _vm._v(" "),
                          _c("div", {
                            attrs: { slot: "no-results" },
                            slot: "no-results"
                          })
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "downloadReportsModal",
          attrs: {
            "hide-header-close": "",
            id: "reportContent",
            title: _vm.$t("ANALYTICS.REPORT_CONTENT"),
            "header-bg-variant": "light",
            centered: ""
          }
        },
        [
          _c(
            "b-card",
            [
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _vm._v(" " + _vm._s(_vm.$t("COMMON.DATE_RANGE")) + " ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-auto", attrs: { sm: "4" } },
                    [
                      _c("date-picker", {
                        attrs: {
                          range: "",
                          lang: "en",
                          format: "YYYY-MM-DD",
                          clearable: false,
                          width: "220px",
                          confirm: ""
                        },
                        model: {
                          value: _vm.dateRangeCSV,
                          callback: function($$v) {
                            _vm.dateRangeCSV = $$v
                          },
                          expression: "dateRangeCSV"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _vm._v(" " + _vm._s(_vm.$t("COMMON.FILTER_BY")) + " ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-auto", attrs: { sm: "4" } },
                    [
                      _c("b-form-select", {
                        attrs: { id: "filterBy", options: _vm.filterOptions },
                        model: {
                          value: _vm.selectedDateFilterTypeCSV,
                          callback: function($$v) {
                            _vm.selectedDateFilterTypeCSV = $$v
                          },
                          expression: "selectedDateFilterTypeCSV"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.isAdminRole
                ? _c(
                    "b-row",
                    { staticClass: "mb-3" },
                    [
                      _c("b-col", { attrs: { cols: "3" } }, [
                        _vm._v(" " + _vm._s(_vm.$t("TEAMS.TEAMS")) + " ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-auto", attrs: { sm: "4" } },
                        [
                          _c("b-form-select", {
                            staticStyle: { "text-transform": "capitalize" },
                            attrs: { id: "filterBy", options: _vm.teams },
                            model: {
                              value: _vm.expTeamID,
                              callback: function($$v) {
                                _vm.expTeamID = $$v
                              },
                              expression: "expTeamID"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _vm._v(" " + _vm._s(_vm.$t("Users")) + " ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-auto", attrs: { sm: "4" } },
                    [
                      _c("b-form-select", {
                        staticStyle: { "text-transform": "capitalize" },
                        attrs: { id: "filterBy", options: _vm.users },
                        model: {
                          value: _vm.expUserID,
                          callback: function($$v) {
                            _vm.expUserID = $$v
                          },
                          expression: "expUserID"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c("b-col", { attrs: { cols: "11" } }, [
                    _c(
                      "p",
                      { staticStyle: { "text-align": "left", color: "red" } },
                      [
                        _vm._v(
                          " *" +
                            _vm._s(_vm.$t("ANALYTICS.RECENT_FORM_MSG")) +
                            " "
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "secondary" },
                  on: { click: _vm.generateCSV }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.GENERATE")) + " ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: { click: _vm.hidedownloadReportsModal }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CLOSE")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18d0b24e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18d0b24e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/reports/Form.vue
// module id = 1251
// module chunks = 2